import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { WebhookIntegrationRecord } from "../WebhookIntegrationRecord";

interface UpdateWebhookIntegrationApiKeyParams {
  webhookEndpointId: string;
  apiKey: string;
}

export function useUpdateWebhookIntegrationApiKey() {
  const { integrationService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    WebhookIntegrationRecord,
    Error,
    UpdateWebhookIntegrationApiKeyParams
  >({
    mutationFn: ({ webhookEndpointId, apiKey }) => {
      return integrationService
        .updateWebhookIntegrationApiKey(webhookEndpointId, apiKey)
        .then((response) => {
          queryClient.setQueryData(
            ["webhookEndpointId", response.webhook_endpoint_id],
            response,
          );
          return response;
        });
    },
  });
}
